import { useState } from "react";

const useForm = (data) => {
  const [form, setForm] = useState(data);
  const [touch, setTouch] = useState({});
  const [validations, setValidations] = useState({});

  const onHandleChange = (name, value) => setForm({ ...form, [name]: value });
  const onHandleTouch = (name, value) => setTouch({ ...touch, [name]: value });
  const onHandleValidate = (name, value, validator) => {
    const validation = validator(value);
    setValidations({ ...validations, [name]: validation });
    return validation;
  };
  const onValidateForm = (form, validator) => {
    let validations = {};
    let touch = {};

    for (const attr in form) {
      const result = validator[attr](form[attr]);

      if (result) {
        validations[attr] = result;
        touch[attr] = form[attr];
      }
    }

    if (Object.keys(validations).length) {
      setValidations(validations);
      setTouch(touch);
    }

    return validations;
  };

  return {
    form,
    touch,
    validations,
    onHandleChange,
    onHandleTouch,
    onHandleValidate,
    onValidateForm,
  };
};

export default useForm;
